import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { UserThreeIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createStaff } from '../../api/staff/create-staff'
import { checkSsnDataValidity } from '../../api/staff-application/check-ssn-data-validity'
import UserNavBar from '../../components/elements/nav-bar'
import StaffForm from '../../components/pages/staff/staff-form/staff-form'
import { Paths } from '../../lib/constants/path'
import { DocumentStatusEnum } from '../../lib/types/enums/common/document-status.enum'
import { LanguageEnum } from '../../lib/types/enums/languages/language.enum'
import { LanguageLevelEnum } from '../../lib/types/enums/languages/language-level.enum'
import { twoButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../lib/utils/functions/misc.functions'

const CreateStaffProfilePage = () => {
  const { navigate, back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createStaff,
    onError: showAxiosError,
    onSuccess: () => {
      toast.success("Profil de l'encadrant créé avec succès")
      navigate(Paths.STAFF_LIST_PAGE)
    }
  })

  const { mutateAsync: checkSsn } = useMutation({
    mutationFn: checkSsnDataValidity,
    onError: showAxiosError
  })

  return (
    <div>
      <UserNavBar title="Profil de l'encadrant" icon={UserThreeIcon} />
      <div className="h-4" />
      <Box>
        <StaffForm
          buttonsConfig={twoButtonsConfig({
            onCancel: () => back(),
            onConfirm: async (values) => {
              const { socialSecurityNumber, ...rest } = values
              const ssnWithoutSpaces = socialSecurityNumber?.replace(/\s/g, '') ?? undefined

              if (ssnWithoutSpaces) {
                const ssnCheck = await checkSsn({
                  ssn: ssnWithoutSpaces,
                  birthPlace: rest.birthPlace,
                  birthDate: rest.birthDate,
                  gender: rest.gender,
                  birthDepartment: rest.birthDepartment ?? undefined
                })
                if (ssnCheck.valid === false) return
              }
              await mutateAsync({
                ...rest,
                socialSecurityNumber: ssnWithoutSpaces
              })
            }
          })}
          mode={'create'}
          defaultValues={{
            idStatus: DocumentStatusEnum.PENDING,
            criminalRecordStatus: DocumentStatusEnum.PENDING,
            paySlipStatus: DocumentStatusEnum.PENDING,
            diplomas: [],
            availabilities: [],
            classLevels: [],
            qualifications: [],
            formulasWishListIds: [],
            countriesWishListIds: [],
            hobbyIds: [],
            comments: [],
            partOfTheEuropeanUnion: true,
            canModify: true,
            hasComplemenaryInsurance: false,
            languages: Object.values(LanguageEnum).map((language) => ({
              language,
              level: LanguageLevelEnum.NOT_PRACTICED
            }))
          }}
        />
      </Box>
    </div>
  )
}

export default CreateStaffProfilePage
